import { api } from 'agent';
import { UserDTO } from './dtos/UserDTO';

export default function getUser(): Promise<UserDTO> {
  return api.get(`user`).then((response: { data: UserDTO }) => response.data);
}
